import { type FC } from 'react'
import { UpsellBodyLayout } from '../../Common/UpsellBodyLayout'
import { UpsellFeatureItem } from '../../Common/UpsellFeatureItem'
import BusinessEventsPromo from '../../../../assets/images/promo-business-events.png'

import './BusinessEventsUpsell.scss'

export const BusinessEventsUpsellBody: FC = () => {
  return (
    <UpsellBodyLayout
      image={<img src={BusinessEventsPromo} alt='Client signals promo' className='zocks-border-0.5 business-events-upsell-promo object-fit-contain' />}
      heading={
        <>
          Automate with <span className='zocks-text-primary'>Client Signals</span>
        </>
      }
      description='Your AI Assistant detects important signals from meetings - such as life events and referrals - then triggers your Zapier workflows automatically.'
    />
  )
}

export const BusinessEventsUpsellFeatures: FC = () => {
  return (
    <>
      <UpsellFeatureItem title='Spot opportunities' description='Life events and referrals are highlighted in every meeting note' />
      <UpsellFeatureItem title='Save hours on data entry' description='Signals flow to Zapier without manual updates' />
      <UpsellFeatureItem title='Never miss a follow-up' description='Trigger workflows the moment signals are detected' className='mb-3' />
    </>
  )
}
